/**
 * @module events/types/pointerEnter
 */

/**
 * @type {string}
 */
export default 'pointerenter'
